import { HttpClientService } from '../http-client/http-client.service';
import { Subscriber } from 'rxjs/Subscriber';
import { Service } from '../service';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { SubjectTeacherDto } from '../../models/divisions/division-subject';
import { AddStudentDto } from '../../models/students/dto/AddStudentDto';

@Injectable()
export class SubjectDivisionTeacherService extends Service {
    constructor(private http: HttpClientService) {
        super();
    }

    public getAllByDivision(divisionId: number): Observable<SubjectTeacherDto[]> {
        const url = 'subjectdivisionteacher/allbydivision/' + divisionId;
        return this.http.get(url).map(response => {
            const r = response.json();
            let subjectDivisionTeacher = [];
            if (r.ResultCode === 1) {
                subjectDivisionTeacher = r.Result;
            } else {
                console.error('SubjectDivisionTeacherService > getAll > response', r);
            }
            return subjectDivisionTeacher;
        }).catch(this.handleError);
    }

    public add(data: any) {
        const url = 'subjectdivisionteacher/add';
        return this.http.post(url, data).map(response => response.json())
            .catch(this.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/main/services/subject-division-teachers/subject-division-teacher.service.ts